requirejs.config({
    "baseUrl": "/scripts",
    "paths": {
        "facebook": "//connect.facebook.net/pl_PL/sdk",
        "app": "app-7680544076",
        "bag": "bag-d41d8cd98f",
        "banner": "banner-98b33a31b1",
        "buttons": "buttons-d41d8cd98f",
        "callbacks": "callbacks-974e5c640e",
        "category-filter": "category-filter-fe7a556592",
        "category": "category-afd9d4ba0e",
        "expandable": "expandable-8d645d0cef",
        "search-bar": "search-bar-edeb16f0b7",
        "search": "search-2abb38f86e",
        "select": "select-d41d8cd98f",
        "sidebar": "sidebar-6a4c88fd75",
        "slider": "slider-b717cc22c5",
        "tabs": "tabs-9a821c8047",
        "tools": "tools-046a4f9a28",
        "tree": "tree-d41d8cd98f",
        "jquery.bxslider": "../vendor/jquery.bxslider-102aa14f28",
        "jquery.fancybox": "../vendor/jquery.fancybox-e8562b1172",
        "jquery.fancybox.pack": "../vendor/jquery.fancybox.pack-a5d70da481",
        "jquery": "../vendor/jquery-d43ef025b6",
        "jquery.mousewheel": "../vendor/jquery.mousewheel-fdf242ae60",
        "require": "../vendor/require-81763feb12"
    },
    "shim": {
        "jquery": "$",
        "facebook": {
            "exports": "FB"
        },
        "jquery.fancybox": [
            "jquery"
        ],
        "jquery.ui.widget": [
            "jquery"
        ]
    }
});
require(['app'], function(app){
    app.run();
});